module.exports = __webpack_public_path__ + "front/img/b18.5bfbb9ed.jpg";